'use client';

import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useReducer } from 'react';
import { PropsWithChildren } from 'react';

interface SuccessScorecardButtonProps {
  className: string;
}

const SuccessScorecardButton = (props: PropsWithChildren<SuccessScorecardButtonProps>) => {
  const { className, children } = props;

  const [isOpen, toggleOpen] = useReducer((open: boolean) => !open, false);

  return (
    <>
      <button type="button" className={className} onClick={toggleOpen}>
        {children}
      </button>

      <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
        <div className="modal-box overflow-auto">
          <div className="flex justify-end">
            <button type="button" className="btn btn-ghost text-gray-400 -mt-4 -mr-4" onClick={toggleOpen}>
              <FontAwesomeIcon icon={faXmark} size='2x' />
            </button>
          </div>

          <p className="text-primary text-xl font-semibold mb-10 text-center">
            We just need a few details to get started.
          </p>

          {isOpen ? (
            <iframe src="https://success.thesalon.app/form" width="100%" height="400px" frameBorder="0" />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default SuccessScorecardButton;
